import { canv } from '@/canv/global.js'
import { sleep, getTarget, logException } from '@/canv/utils.js'

export class reconnectWindow {

    constructor() {
        var reconnectWindowWrapper = document.createElement('div');
        reconnectWindowWrapper.classList.add("reconnectWindowWrapper");
        document.body.prepend(reconnectWindowWrapper);

        reconnectWindowWrapper.innerHTML += this.getMenu();

        var menu = document.getElementsByClassName("reconnectWindowWrapper")[0];
        menu.style.opacity = 1;
        menu.style.display = "none";
    }


    async show() {
        // Не показываем окно переподключения во время экспорта PDF
        if (canv.isHighPdfExporting) {
            return;
        }

        var menu = document.getElementsByClassName("reconnectWindowWrapper")[0];
        menu.style.display = "grid";
        this.showed = true;

        await sleep(500);


        try {
            // бесконечно ждем переподвключения
            await canv.connectAndLoadCanvas();
            this.hide();
        } catch (e) {
            this.hide();
            logException(e);
            return;
        }
    }

    hide() {
        var reconnectWindowWrapper = document.getElementsByClassName("reconnectWindowWrapper")[0];
        if (reconnectWindowWrapper != undefined) {
            reconnectWindowWrapper.style.display = "none";
            this.showed = false;
        }
    }


    // Templates


    getMenu() {

        var template = `
            <div class="reconnectWindow">
                <div class="reconnectWindowInfo">переподключение</div>
            </div>
        `;

        return template;
    }

    showed = false;
}
